import { createFileRoute } from '@tanstack/react-router';
import GuidedSetupAdmin from 'containers/GuidedSetupAdmin';

export const Route = createFileRoute('/_authenticated/guidedSetups')({
  component: GuidedSetupAdmin,
});
